import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header.component';
import { DashboardSettingModule } from '../_components/dashboard-setting/dashboard-setting.module';
import { PipeModule } from '../_pipes/pipe.module';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PipeModule,
    OverlayModule,
    DashboardSettingModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HeaderModule {
}
